export default "__VITE_ASSET__81abafb1__"